// This controls the search modal. The password modal extends from this class.
// TODO: Refactor this and details-disclosure into one component. -ae 01.09.2024
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    // Store the header element from outside the component
    this.header = document.querySelector("#shopify-section-header");
    // Store the modal-overlay element
    this.cloak = document.querySelector(".modal-overlay");

    this.detailsContainer.addEventListener(
      "keyup",
      (e) => e.key.toUpperCase() === "ESCAPE" && this.close()
    );

    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
    this.summaryToggle.setAttribute("aria-expanded", "false");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(e) {
    e.preventDefault();
    e.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(e);
  }

  onBodyClick(e) {
    if (
      !this.contains(e.target) ||
      e.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(e) {
    this.classList.add("is-open");
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    e.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);

    document.body.classList.add("overflow-hidden");
    if (this.cloak.getAttribute("open") === null) {
      this.cloak.setAttribute("open", true);
    }

    this.header.classList.add("nav-open");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.classList.remove("is-open");
    this.detailsContainer.removeAttribute("open");

    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");

    setTimeout(() => {
      if (this.header.querySelector("details[open]") === null) {
        this.header.classList.remove("nav-open");
        this.cloak.removeAttribute("open");
      }
    });
  }
}

customElements.define("details-modal", DetailsModal);
